import { Action } from "@ngrx/store";
import { ICategories } from "../models/categoriesresponse.model";
import { ISubCategories } from "../models/sub-categoriesresponse.model";

export enum ESubCategoriesActions {
  GetSubCategories = "[SubCategories] Get SubCategories",
  GetSubCategoriesSuccess = "[SubCategories] Get SubCategories Success",
}

export class GetSubCategories implements Action {
  public readonly type = ESubCategoriesActions.GetSubCategories;
  constructor(public payload: string) {}
}

export class GetSubCategoriesSuccess implements Action {
  public readonly type = ESubCategoriesActions.GetSubCategoriesSuccess;
  constructor(public payload: ISubCategories) {}
}

export type SubCategoriesActions = GetSubCategories | GetSubCategoriesSuccess;
